import { render, staticRenderFns } from "./custom-viewer.vue?vue&type=template&id=16883877&scoped=true"
import script from "./custom-viewer.vue?vue&type=script&lang=js"
export * from "./custom-viewer.vue?vue&type=script&lang=js"
import style0 from "./custom-viewer.vue?vue&type=style&index=0&id=16883877&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16883877",
  null
  
)

export default component.exports